import { SectionHeading } from '@/components/ds/SectionHeading'
import { StatusPage } from '@/components/ds/StatusPage'
import { Button } from '@/components/ui/button'

const Maintenance = () => {
  return (
    <StatusPage>
      <SectionHeading
        level={1}
        th="กำลังปรับปรุงระบบ"
        en="Under maintenance"
        description="เรากำลังปรับปรุงระบบเพื่อประสบการณ์การสมัครที่ดีขึ้น กรุณาลองใหม่อีกครั้งในภายหลัง"
      />
      <Button className="mt-8" onClick={() => window.location.reload()}>
        ลองใหม่อีกครั้ง
      </Button>
    </StatusPage>
  )
}

export default Maintenance
